module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/alert-buttons/alert-buttons.component.scss
// module id = ./src/app/features/buttons/alert-buttons/alert-buttons.component.scss
// module chunks = main